import customTheme from '~/themes/custom'

export default defineAppConfig({
  ui: customTheme
})